<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="customerEnvironmentConfiguration.pkId > 0 ? '编辑' : '新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customerEnvironmentConfiguration"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="客户" prop="customerName">
          <div style="display: flex; flex-direction: row">
            <el-input v-model="customerEnvironmentConfiguration.customerName" placeholder="请选择客户" readonly>
              <el-button slot="append" @click="$refs.selectCustomerName.open()">选择</el-button>
            </el-input>
            <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
          </div>
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input v-model="customerEnvironmentConfiguration.username" placeholder="请输入账号"/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="customerEnvironmentConfiguration.password" type="password" placeholder="请输入密码"/>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPd">
          <el-input v-model="customerEnvironmentConfiguration.confirmPd" type="password" placeholder="请输入确认密码"/>
        </el-form-item>
        <el-form-item label="地址" prop="apiBaseUrl">
          <el-input v-model="customerEnvironmentConfiguration.apiBaseUrl" type="textarea" autosize placeholder="请输入地址"/>
        </el-form-item>
        <el-form-item label="Token有效期" prop="tokenAging">
          <el-input v-model="customerEnvironmentConfiguration.tokenAging" placeholder="请输入Token有效期"/>
        </el-form-item>
        <el-form-item label="自有物料" prop="materialMapping">
          <el-radio-group v-model="customerEnvironmentConfiguration.materialMapping">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import CustomerSelect from "../../information/Customer/CustomerSelect";
  export default {
    components: { CustomerSelect },
    data() {
      return {
        constant,
        configTypes: constant.toSelect(constant.configTypes),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        customerEnvironmentConfiguration: {
          pkId: 0,
          customerName: "",
          customerId: 0,
          username: "",
          password: "",
          confirmPd: "",
          apiBaseUrl: "",
          tokenAging: 0,
          materialMapping: true,
        },
        ruleValidate: {
          customerName: { required: true, message: "请选择客户", trigger: "change" },
          username: { required: true, message: "请输入账号", trigger: "blur" },
          password: { required: true, message: "请输入密码", trigger: "blur" },
          confirmPd: { required: true, message: "请输入确认密码", trigger: "blur" },
          apiBaseUrl: { required: true, message: "请输入地址", trigger: "blur" },
          tokenAging: { required: true, message: "请输入Token有效期", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        // this.customerEnvironmentConfiguration.username = "";
        // this.customerEnvironmentConfiguration.password = "";
        this.dialogVisible = true;
        if (row) {
          this.customerEnvironmentConfiguration.pkId = row.pkId;
          this.getData();
        }
      },

      // 根据id查询详细信息
      getData() {
        this.$http.get("basic", `customerDevelopers/${this.customerEnvironmentConfiguration.pkId}`).then((resp) => {
          if (resp.success) {
            this.customerEnvironmentConfiguration = Object.assign(this.customerEnvironmentConfiguration, resp.data);
            this.customerEnvironmentConfiguration.confirmPd = this.customerEnvironmentConfiguration.password;
          }
        });
      },

      // 选择客户
      selectCustomerName(row) {
        this.customerEnvironmentConfiguration.customerId = row.customerID;
        this.customerEnvironmentConfiguration.customerName = row.customerName;
      },

      // 提交
      handleSubmit() {
        if (this.customerEnvironmentConfiguration.password !== this.customerEnvironmentConfiguration.confirmPd) {
          this.$confirm("密码输入不一致", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.customerEnvironmentConfiguration.pkId > 0) {
          this.handleSubmitUpData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "customerDevelopers", this.customerEnvironmentConfiguration)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "customerDevelopers", this.customerEnvironmentConfiguration)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
